import { IconButton, Stack, Typography } from '@mui/material';
import {
  LIVE_TRANSCRIPT_COPY_BUTTON_CLASS,
  liveTranscriptCopyButtonSx,
  liveTranscriptCopyIconSx,
  liveTranscriptMessageBubbleSx,
  liveTranscriptMessageContainerSx,
  liveTranscriptMessageRowSx,
  liveTranscriptSpeakerChangeSx,
} from 'src/components/Assistant/live-transcript/live-transcript.styles';
import {
  LiveTranscriptMessageProps,
  LiveTranscriptRole,
} from 'src/components/Assistant/live-transcript/live-transcript.types';
import { renderTextWithHighlights } from 'src/components/Assistant/live-transcript/transcript-search-highlight';
import { DynamicIcon } from 'src/components/DynamicIcon/dynamic-icon';
import { useDisplayTime } from 'src/utils/hooks/use-display-time';

export const LiveTranscriptMessage = ({
  segment,
  showSpeakerChange,
  onCopy,
  searchQuery,
  matchOffset,
  currentMatchIndex,
}: LiveTranscriptMessageProps) => {
  const isAgent = segment.role === LiveTranscriptRole.Agent;
  const { displayTime } = useDisplayTime();

  return (
    <Stack sx={liveTranscriptMessageContainerSx(isAgent)}>
      {showSpeakerChange ? (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={liveTranscriptSpeakerChangeSx}
        >
          {isAgent ? 'Agent' : 'Client'} • {displayTime(segment.timestamp)}
        </Typography>
      ) : null}

      <Stack direction={isAgent ? 'row-reverse' : 'row'} sx={liveTranscriptMessageRowSx}>
        <Stack sx={liveTranscriptMessageBubbleSx(isAgent)}>
          <Typography variant="body2">
            {renderTextWithHighlights({
              text: segment.transcriptionText,
              query: searchQuery,
              matchOffset,
              currentMatchIndex,
            })}
          </Typography>
        </Stack>

        <IconButton
          className={LIVE_TRANSCRIPT_COPY_BUTTON_CLASS}
          aria-label="Copy message"
          size="small"
          onClick={() => onCopy(segment.transcriptionText)}
          sx={liveTranscriptCopyButtonSx}
        >
          <DynamicIcon name="content_copy" sx={liveTranscriptCopyIconSx} />
        </IconButton>
      </Stack>
    </Stack>
  );
};
